export function rgbaToHsla(rgba: string): string {
    if (!rgba || typeof rgba !== 'string') return '0, 0%, 0%, 1'

    // Parse RGBA values
    const match = rgba.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d*(?:\.\d+)?))?\)/)
    if (!match) return '0, 0%, 0%, 1'

    let r = parseInt(match[1]) / 255
    let g = parseInt(match[2]) / 255
    let b = parseInt(match[3]) / 255
    let a = match[4] ? parseFloat(match[4]) : 1

    let max = Math.max(r, g, b), min = Math.min(r, g, b)
    let h = 0, s, l = (max + min) / 2

    if (max === min) {
        h = s = 0 // achromatic
    } else {
        let d = max - min
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min)
        switch (max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break
            case g: h = (b - r) / d + 2; break
            case b: h = (r - g) / d + 4; break
        }
        h /= 6
    }

    h = Math.round(h * 360)
    s = Math.round(s * 100)
    l = Math.round(l * 100)

    return `${h}, ${s}%, ${l}%, ${a}`
}